import { render } from "./Markdown.vue?vue&type=template&id=ddd3415e"
import script from "./Markdown.vue?vue&type=script&lang=js"
export * from "./Markdown.vue?vue&type=script&lang=js"

import "./Markdown.vue?vue&type=style&index=0&id=ddd3415e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__